import React from 'react';

import { useIsActiveLink } from '@src/hooks/use-is-active-link';

import { StyledTextLink } from './styles';

const TextLink = ({ color, hoverColor, to, children, onClick }) => {
  const isActive = useIsActiveLink(to);

  return (
    <StyledTextLink color={color} $hoverColor={hoverColor} to={to} $active={isActive} onClick={onClick}>
      {children}
    </StyledTextLink>
  );
};

export default TextLink;
